<div class="header">
  <img src="assets/logo.png" class="logo">
</div>
<div class="error">
  お探しのページは見つかりませんでした。
  <br /><br />
  URLが変更・削除されたか、一時的に閲覧できない可能性があります。
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
</div>
